(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  document.querySelectorAll('.cart-upsell-prompt__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.disabled = true;
      var variantId = parseInt(btn.dataset.variantId, 10);
      var newQty    = parseInt(btn.dataset.newQty, 10);
      var updates   = {};
      updates[variantId] = newQty;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function () { window.location.reload(); })
      .catch(function () { btn.disabled = false; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // ── Sort: preserve all active filter params when changing sort ──
  var sortSelect = document.getElementById('col-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (this.value === 'manual') {
        url.searchParams.delete('sort_by');
      } else {
        url.searchParams.set('sort_by', this.value);
      }
      window.location = url.toString();
    });
  }

  // ── Filter dropdowns: toggle open/close ──
  var filterBtns = document.querySelectorAll('.col-filter__btn');
  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      // Close all panels first
      filterBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        document.getElementById(b.getAttribute('aria-controls')).hidden = true;
      });
      // Open clicked one if it was closed
      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        document.getElementById(this.getAttribute('aria-controls')).hidden = false;
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.col-filter')) {
      filterBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      });
    }
  });

  // Close dropdowns on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      filterBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      });
    }
  });

  // ── Sort / shuffle product cards ──
  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.querySelector('.collection-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.children);
    if (window.__bgSort === 'title-ascending') {
      // Re-sort client-side with Norwegian locale so Æ, Ø, Å order correctly
      cards.sort(function (a, b) {
        return a.dataset.title.localeCompare(b.dataset.title, 'nb', { sensitivity: 'base' });
      });
      cards.forEach(function (card) { grid.appendChild(card); });
    } else {
      // Fisher-Yates shuffle for "Anbefalt" and other server-sorted views
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        grid.appendChild(cards[j]);
        cards.splice(j, 1);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  var STORAGE_KEY = 'bg-wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateAllBadges();
  }

  function updateAllBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('.wishlist-badge').forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateButton(btn) {
    var handle = btn.dataset.handle;
    var inList = getWishlist().includes(handle);
    btn.querySelector('.btn-wishlist__icon').textContent = inList ? '♥' : '♡';
    btn.querySelector('.btn-wishlist__text').textContent = inList ? 'Fjern fra ønskeliste' : 'Ønskeliste +';
    btn.classList.toggle('btn-wishlist--active', inList);
  }

  document.querySelectorAll('.btn-wishlist').forEach(function (btn) {
    updateButton(btn);
    btn.addEventListener('click', function () {
      var handle = btn.dataset.handle;
      var items = getWishlist();
      if (items.includes(handle)) {
        items = items.filter(function (h) { return h !== handle; });
      } else {
        items.push(handle);
      }
      saveWishlist(items);
      updateButton(btn);
    });
  });

  updateAllBadges();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORAGE_KEY = 'bg-wishlist';
  var grid = document.getElementById('wishlist-grid');
  var empty = document.getElementById('wishlist-empty');

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function updateAllBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('.wishlist-badge').forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function removeFromWishlist(handle) {
    var items = getWishlist().filter(function (h) { return h !== handle; });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateAllBadges();
  }

  function showEmpty() {
    empty.style.display = 'block';
    grid.style.display = 'none';
  }

  var handles = getWishlist();
  updateAllBadges();

  if (handles.length === 0) {
    showEmpty();
    return;
  }

  Promise.all(handles.map(function (handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  })).then(function (products) {
    var valid = products.filter(Boolean);
    if (valid.length === 0) { showEmpty(); return; }

    valid.forEach(function (product) {
      var price = (product.price / 100).toLocaleString('nb-NO') + ',-';
      var image = product.featured_image || '';
      var card = document.createElement('div');
      card.className = 'wishlist-card';
      card.innerHTML =
        '<a href="/products/' + product.handle + '" class="wishlist-card__image-link">' +
          '<img src="' + image + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' +
        '</a>' +
        '<div class="wishlist-card__info">' +
          '<p class="wishlist-card__vendor">' + (product.vendor || '') + '</p>' +
          '<h3 class="wishlist-card__title"><a href="/products/' + product.handle + '">' + product.title + '</a></h3>' +
          '<p class="wishlist-card__price">fra ' + price + '</p>' +
        '</div>' +
        '<button class="wishlist-card__remove" data-handle="' + product.handle + '" aria-label="Fjern fra ønskeliste">\u2715</button>';

      card.querySelector('.wishlist-card__remove').addEventListener('click', function (e) {
        var h = e.currentTarget.dataset.handle;
        removeFromWishlist(h);
        card.remove();
        if (document.querySelectorAll('.wishlist-card').length === 0) showEmpty();
      });

      grid.appendChild(card);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
